import { usersInfoRequest } from "../../services/requests/auth";
import { $snack } from "../../services/snack";

export default function auth({ next, store }) {
  return new Promise((resolve, reject) => {
    if (!store.getters.getIsLogged) {
      reject(next({ name: "login" }));
    }
    if (store.getters.getIsLogged && !store.getters.getUser) {
      return usersInfoRequest()
        .then((res) => {
          store.dispatch("setUser", res.data.data);
          let address = res.data.data.address;
          if (address) {
            address = {
              ...address,
              num: address.number,
            };
          }
          store.dispatch("setAddress", address);
          resolve();
        })
        .catch(() => {
          store.dispatch("logout");
          $snack.error("Faça seu login novamente");
          reject(next({ name: "login" }));
        });
    }
    resolve();
  });
}
